module.exports = __webpack_public_path__ + "static/media/cq_editor_intestazione6 b.b22185ca.svg";